import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-d76a0e67',
  styleUrl: './md-d76a0e67.css',
  templateUrl: './md-d76a0e67.html',
})
export class MdD76a0e67 {
  readonly config = ENTITY_CONFIGS['d76a0e67'];
}
